import { ComponentType } from 'react';

const RELOAD_KEY = 'yvis:chunk-reload';

const readReloaded = () => {
  try {
    return sessionStorage.getItem(RELOAD_KEY) === '1';
  } catch {
    return false;
  }
};

const writeReloaded = (value: boolean) => {
  try {
    if (value) sessionStorage.setItem(RELOAD_KEY, '1');
    else sessionStorage.removeItem(RELOAD_KEY);
  } catch {
    // sessionStorage 를 못 쓰는 환경이면 재시도 없이 에러로 넘긴다
  }
};

// createBrowserRouter 의 route.lazy 용 로더.
// 배포로 청크 해시가 바뀌면 웹뷰에 떠 있던 옛 main.js 가 없는 청크를 요청해 실패한다.
// 이때 한 번만 새로고침해 새 main.js 를 받는다. 새로고침 후에도 실패하면 에러를 그대로 던진다.
const lazyPage =
  (load: () => Promise<{ default: ComponentType }>) => async () => {
    try {
      const module = await load();
      writeReloaded(false);
      return { Component: module.default };
    } catch (error) {
      if (readReloaded()) throw error;

      writeReloaded(true);
      window.location.reload();
      // 새로고침될 때까지 라우터가 에러 화면을 그리지 않도록 대기
      return new Promise<never>(() => undefined);
    }
  };

export default lazyPage;
